import React, { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
type SpotifyContextType = {
  openSpotifyPlayer: () => void;
};
const SpotifyContext = createContext<SpotifyContextType | undefined>(undefined);
export const useSpotify = (): SpotifyContextType => {
  const context = useContext(SpotifyContext);
  if (!context) {
    throw new Error('useSpotify must be used within a SpotifyProvider');
  }
  return context;
};
interface SpotifyProviderProps {
  children: React.ReactNode;
  openPlayer: () => void;
}
export const SpotifyProvider: React.FC<SpotifyProviderProps> = ({
  children,
  openPlayer
}) => {
  const navigate = useNavigate();
  const openSpotifyPlayer = () => {
    // Navigate to the listen page instead of opening the player at the bottom
    navigate('/listen');
  };
  return <SpotifyContext.Provider value={{
    openSpotifyPlayer
  }} data-id="element-562">
      {children}
    </SpotifyContext.Provider>;
};